import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setRecentContents } from 'actions/document';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { setTemplate } from 'actions/templates';

import { dashboardTools } from 'components/private/sections/newWritingTools';
import { getModifiedTime } from 'utils/getModifiedTime';
import Icon from 'components/common/Icon';

import './index.scss';

const RecentContent = ({
    recentContents: { document: { recentContents } },
    setRecentContents,
    setTemplateClick
}) => {
    const [isSeeAll, setIsSeeAll] = useState(false);
    const history = useHistory();

    useEffect(() => {
        setRecentContents(2);
    }, []);

    const handleSeeAll = () => {
        setRecentContents('all');
        setIsSeeAll(true)
    }

    const handleSeeLess = () => {
        setRecentContents(2);
        setIsSeeAll(false)
    };

    const handleOpenTemplate = async (findedTemplate, templateId) => {
        setTemplateClick(findedTemplate);
        history.push({ pathname: "/tools/template", state: { templateId } });

        // const res = await axios.get(`/api/documents/findone/${templateId}`);
    }

    //recentContents

    return <div className='recent__content__wrapper'>
        {
            recentContents.length ? <>
                <div className='top__section__wrapper'>
            <h2>Recent content</h2>
            {
                !isSeeAll ? <span onClick={handleSeeAll}>See all</span> : <span onClick={handleSeeLess}>See less</span>
            } 
        </div>
        <div className='bottom__section__wrapper'>
            <div className='tabel__top__wrapper'>
                <span>Name</span>
                <span>Last modified</span>
                <div></div>
            </div>
            <div className='templates__wrapper'>
                    {
                        recentContents.map(tool => {
                            const findedTemplate = dashboardTools.find(template => template.title === tool.title);
                            return (
                                <div key={tool._id} className='template'>
                                    <div className='tamplate__info__wrapper'>
                                        <Icon name={findedTemplate?.icon} />
                                        <div className='texts__wrapper'>
                                            <span>{tool.title}</span>
                                            <span>{findedTemplate?.description}</span>
                                        </div>
                                    </div>
                                    <div className='modified__wrapper'>
                                        <span>{getModifiedTime(tool.date)}</span>
                                    </div>
                                    <div onClick={() => handleOpenTemplate(findedTemplate, tool._id)} className='open__icon__wrapper'>
                                        <span>Open</span>
                                        <Icon name='Open' />
                                    </div>
                                </div>
                            )
                        })
                        }
                </div>
            </div>
            </> : null
        }
    </div>
};

const mapStateToProps = (state) => {
    return {
        recentContents: state
    }
};

const mapDispatchToProps = (dispatch) => ({
    setRecentContents: (limit) => dispatch(setRecentContents(limit)),
    setTemplateClick: (template) => dispatch(setTemplate(template))
})

export default connect(mapStateToProps, mapDispatchToProps)(RecentContent);